<template>
    <v-app v-if="$route.name != '404' && $route.name != 'client' && $route.name != 'specialist'">
        <Header />
        <router-view id="twayHome" class="tway-content" />
        <Footer />
    </v-app>
    <v-app v-else>
        <router-view id="twayHome" class="tway-content" />
    </v-app>
</template>
<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default {
    name: 'App',

    components: {
        Header,
        Footer,
    }
};
</script>